// extracted by mini-css-extract-plugin
module.exports = {"purchase-wrapper":"header-jek_purchase-wrapper__K8OFo"};